import React, {useMemo} from "react";
import {PartSupportRequestInformationRowDataGridCellKeys} from "../../../../../core/constants/table/data-grid-column-keys";
import {dataGridCellTextProps, DataGridColumnAlignments, DataGridColumnTypes, useDataGridSavedState} from "../../../../../packages/data-grid";
import PartnerDataGrid from "../../../../containers/data-grid";
import CopyToClipboard from "../../../base/copy-to-clipboard";
import IconButton from "../../../base/button/icon_button";
import {SvgIcon} from "@mui/material";
import {ReactComponent as Copy} from '../../../../../assets/images/copy.svg';
import ProductInformationPopover from "../../draggable-popover/product-information-popover";

const PartSupportRequestInformationRow = ({
                                              data,
                                              saveConfig,
                                              exclude = [],
                                          }) => {

    const columns = useMemo(() =>
            /**@type {DataGridColumn[]}*/
            [
                {
                    title: "RGA",
                    name: PartSupportRequestInformationRowDataGridCellKeys.rga,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    pinned: true,
                    sortable: false,
                    width: 50,
                },
                {
                    title: "Type",
                    name: PartSupportRequestInformationRowDataGridCellKeys.type,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                    width: 50,
                },
                {
                    title: "Status",
                    name: PartSupportRequestInformationRowDataGridCellKeys.status,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
                {
                    title: "Product",
                    name: PartSupportRequestInformationRowDataGridCellKeys.partNo,
                    alignment: DataGridColumnAlignments.center,
                    type: DataGridColumnTypes.element,
                    sortable: false,
                },
                {
                    title: "Customer",
                    name: PartSupportRequestInformationRowDataGridCellKeys.customer,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
                {
                    title: "Warehouse Code",
                    name: PartSupportRequestInformationRowDataGridCellKeys.warehouseCode,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                    width: 120,
                },
                {
                    title: 'Vendor Name',
                    name: PartSupportRequestInformationRowDataGridCellKeys.vendorName,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
                {
                    title: 'Vendor Code',
                    name: PartSupportRequestInformationRowDataGridCellKeys.vendorCode,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
                {
                    title: "Invoice No",
                    name: PartSupportRequestInformationRowDataGridCellKeys.invoiceNo,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
                {
                    title: 'Serial No',
                    name: PartSupportRequestInformationRowDataGridCellKeys.serialNo,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.element,
                    sortable: false,
                },
                {
                    title: 'Quantity',
                    name: PartSupportRequestInformationRowDataGridCellKeys.quantity,
                    alignment: DataGridColumnAlignments.left,
                    type: DataGridColumnTypes.string,
                    sortable: false,
                },
            ].filter(e => !exclude.includes(e)),
        [exclude])

    const [dataGridColumns] = useDataGridSavedState({columns: columns, name: saveConfig.name, version: saveConfig.version})

    const dataGridRows = useMemo(() => {
        return data?.map(request => {
            return ({
                key: request.id,
                data: request,
                cells: {
                    [PartSupportRequestInformationRowDataGridCellKeys.rga]: request.rga,
                    [PartSupportRequestInformationRowDataGridCellKeys.type]: request.type,
                    [PartSupportRequestInformationRowDataGridCellKeys.status]: request.status,
                    [PartSupportRequestInformationRowDataGridCellKeys.partNo]:
                        <ProductInformationPopover partNo={request.partNo}>
                            {request.partNo ?? ''}
                        </ProductInformationPopover>,
                    [PartSupportRequestInformationRowDataGridCellKeys.customer]: request.customer?.name,
                    [PartSupportRequestInformationRowDataGridCellKeys.warehouseCode]: request.warehouseCode,
                    [PartSupportRequestInformationRowDataGridCellKeys.vendorName]: request?.vendor?.name,
                    [PartSupportRequestInformationRowDataGridCellKeys.vendorCode]: request?.vendor?.code,
                    [PartSupportRequestInformationRowDataGridCellKeys.invoiceNo]: request.invoiceNo,
                    [PartSupportRequestInformationRowDataGridCellKeys.serialNo]:
                        <>
                            {
                                !!request.serialNo &&
                                <CopyToClipboard>
                                    {({copy}) =>
                                        <IconButton
                                            onPressed={() => copy(request.serialNo ?? '--')}
                                            className={'copy-to-clipboard-button mr-2'}
                                        >
                                            <SvgIcon className={'icon small'} component={Copy}/>
                                        </IconButton>}
                                </CopyToClipboard>
                            }
                            <p {...dataGridCellTextProps} className={'text-sm'}>
                                {request.serialNo ?? 'N/A'}
                            </p>
                        </>,
                    [PartSupportRequestInformationRowDataGridCellKeys.quantity]: request?.unSeriliazablePartsCount ?? 'N/A',
                },
            });
        })
    }, [data])

    return (
        <>
            <PartnerDataGrid
                hideToolbar
                hideFooter
                initialLayoutState={{
                    columns: columns,
                }}
                columns={dataGridColumns}
                rows={dataGridRows}
                visibleRows={data?.length}
                {...(saveConfig ?? {})}
            />
        </>
    )
}

export default PartSupportRequestInformationRow;
